import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, PhoneIcon } from 'lucide-react';
import { QuoteForm } from './QuoteForm';
import { site } from '../data/site';
type Crumb = {
  label: string;
  to?: string;
};
type PageHeroProps = {
  crumbs: Crumb[];
  title: React.ReactNode;
  intro: string;
  defaultService?: string;
  formTitle?: string;
};
export function PageHero({
  crumbs,
  title,
  intro,
  defaultService,
  formTitle = 'Get your free quote'
}: PageHeroProps) {
  return <section className="border-b-4 border-brand bg-ink" data-id="element-270" data-mp="urwrnrpitxpq">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-14 lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:gap-16 lg:px-8 lg:py-20" data-id="element-271" data-mp="urem24gyy755">
        <div data-id="element-272" data-mp="l23isygrjwp6">
          <nav aria-label="Breadcrumb" data-id="element-273" data-mp="l1lc17wh6030">
            <ol className="flex flex-wrap items-center gap-1.5 text-sm font-semibold text-white/60" data-id="element-274" data-mp="l0k0z3fgldla">
              <li data-id="element-275" data-mp="18qmqpcvwi7gq">
                <Link to="/" className="transition-colors duration-150 hover:text-white" data-id="element-276" data-mp="18q4jjl7pa8u1">
                  Home
                </Link>
              </li>
              {crumbs.map(c => <li key={c.label} className="flex items-center gap-1.5" data-id="element-277" data-mp="32g7osu20vvar">
                  <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-278" data-mp="2xksg0givgpl7" />
                  {c.to ? <Link to={c.to} className="transition-colors duration-150 hover:text-white" data-id="element-279" data-mp="3c9g8gdxf8j6x">
                      {c.label}
                    </Link> : <span className="text-white" aria-current="page" data-id="element-280" data-mp="3l7ifba3u6624">
                      {c.label}
                    </span>}
                </li>)}
            </ol>
          </nav>

          <h1 className="mt-5 font-display text-5xl font-extrabold uppercase leading-[0.95] text-white sm:text-6xl" data-id="element-281" data-mp="3v6hhqay0d5go">
            {title}
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/80" data-id="element-282" data-mp="20sggjjezk6df">{intro}</p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-283" data-mp="1vu56p8ooxvv7">
            <a href={site.phoneHref} className="flex items-center justify-center gap-3 rounded-lg bg-brand px-7 py-4 font-display text-2xl font-bold text-white transition-colors duration-150 hover:bg-brand-dark" data-id="element-284" data-mp="1vvq559e4lyyc">
              <PhoneIcon className="h-6 w-6" aria-hidden="true" data-id="element-285" data-mp="2uift8f8428mm" />
              Call {site.phone}
            </a>
          </div>
          <p className="mt-5 text-sm font-medium text-white/60" data-id="element-286" data-mp="2zjda8ohdwwmj">{site.license} · Local & family-owned</p>
        </div>

        <div id="quote" className="rounded-2xl bg-white p-6 shadow-2xl sm:p-8" data-id="element-287" data-mp="34eslr9rx6gfs">
          <h2 className="font-display text-3xl font-bold leading-tight text-ink" data-id="element-288" data-mp="38gxfe8idbd2f">{formTitle}</h2>
          <p className="mb-5 mt-1 text-ink-muted" data-id="element-289" data-mp="3d9qhspqd69bc">Tell us what needs fixing. We reply within 1 business day.</p>
          <QuoteForm defaultService={defaultService} data-id="element-290" data-mp="3i7i85fbd1ndf" />
        </div>
      </div>
    </section>;
}